import React from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import totalCollected from '../../assets/totalCollected.svg'
import inProgress from '../../assets/inProgress.svg'
import firstGraph from '../../assets/firstGraph.svg'
import secondGraph from '../../assets/secondGraph.svg'
import recentActivityIcon from '../../assets/recentActivityIcon.svg'
import typeOfVariationinShade from '../../assets/typeOfVariationinShade.svg'
import Samples from '../../assets/Samples.svg';
import TypeOfVariation from '../../assets/TypeOfVariation.svg'
import calender from '../../assets/calender.svg'
import moment from 'moment';
import { Input, Col, Row, Button } from 'reactstrap';
import { ComposedChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Line, ResponsiveContainer, LabelList } from "recharts";
import Tour from '../../Tour';
import './dashboard.css';
import "react-datepicker/dist/react-datepicker.css";
import CardImg from 'reactstrap/lib/CardImg';
import CardBody from 'reactstrap/lib/CardBody';
import CardText from 'reactstrap/lib/CardText';
import Card from 'reactstrap/lib/Card';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { LineChart, Legend } from "recharts";
import PropTypes from "prop-types";
import _ from "lodash";
import { Responsive, WidthProvider } from "react-grid-layout";
import HeatmapPreview from './heatmapPreview';
import { withTranslation } from 'react-i18next';
import LocationTrend from '../LocationTrend/locationTrend';


const colors = ['#f58026', '#0f61f5', '#00d168', '#7548c7', '#f53a1b']
const ResponsiveReactGridLayout = WidthProvider(Responsive);

class ShowcaseLayout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentBreakpoint: "lg",
            compactType: "vertical",
            mounted: false,
            layouts: props.initialLayout,
            SamplesPeriod: "",
            CTPeriod: "",
            filterType: "complex_type",
            building: "",
            buildingId: "",
            fromDate: "",
            toDate: "",
            startDateLeft: "",
            startDateRight: "",
            endDateRight: "",
            endDateLeft: "",
            dateSelectedLeft: false,
            dateSelectedRight: false,
            complex_period: "",
            seq_period: "",
            speciesStartDate: "",
            speciesEndDate: "",
            speciesMonth: "",
            speciesYear: "",
            biome_period: "",
            showTrendModal: false,
            showSpeciesGraph: false,
        };

        this.onBreakpointChange = this.onBreakpointChange.bind(this);
        this.onCompactTypeChange = this.onCompactTypeChange.bind(this);
        this.onLayoutChange = this.onLayoutChange.bind(this);
    }

    componentDidMount() {
        moment.locale('pt-br');
        this.applyFilter();
        this.setState({ mounted: true });

        this.refreshInterval = setInterval(() => {
            this.applyFilter();
        }, 30000);
    }

    componentWillUnmount() {
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval);
        }
    }


    componentDidUpdate(prevProps) {
        if (prevProps.initialLayout != this.props.initialLayout) {
            this.setState({ layouts: this.props.initialLayout });
        }
    }

    onBreakpointChange(breakpoint) {
        this.setState({
            currentBreakpoint: breakpoint
        });
    }

    onCompactTypeChange() {
        const { compactType: oldCompactType } = this.state;
        const compactType =
            oldCompactType === "horizontal"
                ? "vertical"
                : oldCompactType === "vertical"
                    ? null
                    : "horizontal";
        this.setState({ compactType });
    }

    onLayoutChange(layout, layouts) {
        this.props.onLayoutChange(layout, layouts);
    }


    columns = [
        {
            Header: this.props.t('dashboard.activity'),
            accessor: 'object',
            width: 130,
            Cell: (props) => {
                const { t } = this.props;
                const value = props.value;
                const translations = {
                    'Room': t('dashboard.room'),
                    'Sample': t('dashboard.sample'),
                    'Result': t('dashboard.result'),
                    'Location': t('dashboard.location'),
                    'Sala': t('dashboard.room'),
                };
                return <span>{translations[value] || value}</span>;
            }
        },
        {
            Header: this.props.t('dashboard.count'),
            accessor: 'count',
            width: 180
        },
        {
            Header: this.props.t('dashboard.dateTime'),
            accessor: 'last_action_time',
            Cell: (props) => {
                let date = new Date(props.value)
                date = moment(date).format('MMM D, YYYY HH:mm')
                return <span>{date}</span>
            },
            width: 200
        },
        {
            Header: this.props.t('dashboard.addedItems'),
            accessor: 'added_values',
            Cell: (props) => {
                const value = props.value;
                if (!value || value === '-') return <span>-</span>;

                // Função para limpar caracteres inválidos e ilegíveis
                const cleanValue = (str) => {
                    if (!str) return '';
                    let cleaned = String(str);
                    cleaned = cleaned.replace(/[\x00-\x1F\x7F-\x9F]/g, '');
                    cleaned = cleaned.replace(/[^\x20-\x7E]/g, '');
                    cleaned = cleaned.replace(/[^\w\s\-_,.()\/]/g, '');
                    return cleaned.trim();
                };

                // Função para validar se um valor é legível
                const isValidValue = (str) => {
                    if (!str || str.length === 0) return false;
                    const hasAlphaNumeric = /[a-zA-Z0-9]/.test(str);
                    const notOnlySpecial = !/^[\s\-_,.()\/]+$/.test(str);
                    return hasAlphaNumeric && notOnlySpecial;
                };

                // Limpar e processar o valor
                let displayValue = cleanValue(String(value));

                // Se após limpeza ficou vazio ou não é válido, mostrar "-"
                if (!displayValue || displayValue.length === 0 || !isValidValue(displayValue)) {
                    return <span>-</span>;
                }

                // SEMPRE truncar para máximo de 12 caracteres visíveis
                const MAX_VISIBLE_CHARS = 30;
                let finalDisplay = '';
                let tooltipText = displayValue;

                // Se for uma string muito longa ou com muitos items
                if (displayValue.length > 15) {
                    // Tentar dividir por vírgula, ponto e vírgula, ou espaço
                    const separators = [',', ';', ' '];
                    let items = [];

                    for (const sep of separators) {
                        if (displayValue.includes(sep)) {
                            items = displayValue.split(sep)
                                .map(item => cleanValue(item))
                                .filter(item => item && item.length > 0);
                            if (items.length > 1) break;
                        }
                    }

                    // Se encontrou múltiplos items válidos
                    if (items.length > 1) {
                        const validItems = items.filter(item => isValidValue(item));

                        if (validItems.length > 0) {
                            const totalItems = validItems.length;
                            const firstItem = validItems[0];

                            // Truncar primeiro item para caber com o contador
                            const counterText = ` (+${totalItems - 1})`;
                            const maxFirstItemLength = MAX_VISIBLE_CHARS - counterText.length;
                            const truncatedFirstItem = firstItem.length > maxFirstItemLength
                                ? firstItem.substring(0, maxFirstItemLength) + '...'
                                : firstItem;

                            finalDisplay = (
                                <>
                                    <strong>{truncatedFirstItem}</strong>
                                    {totalItems > 1 && (
                                        <span style={{ color: '#666', fontSize: '11px' }}>
                                            {counterText}
                                        </span>
                                    )}
                                </>
                            );
                            tooltipText = `${firstItem} e mais ${totalItems - 1} items. Total: ${totalItems} items`;
                        } else {
                            // Se não tem items válidos, truncar diretamente
                            finalDisplay = displayValue.length > MAX_VISIBLE_CHARS
                                ? displayValue.substring(0, MAX_VISIBLE_CHARS) + '...'
                                : displayValue;
                        }
                    } else {
                        // Se não conseguiu dividir, truncar diretamente
                        finalDisplay = displayValue.length > MAX_VISIBLE_CHARS
                            ? displayValue.substring(0, MAX_VISIBLE_CHARS) + '...'
                            : displayValue;
                    }
                } else {
                    // Para valores menores, mostrar completo
                    finalDisplay = displayValue;
                }

                return (
                    <span
                        style={{
                            fontSize: '13px',
                            display: 'inline-block',
                            maxWidth: '200px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}
                        title={tooltipText}
                    >
                        {finalDisplay}
                    </span>
                );
            },
            width: 220,
            minWidth: 220,
            maxWidth: 220,
            headerStyle: {
                width: '220px',
                minWidth: '220px',
                maxWidth: '220px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            },
            style: {
                width: '220px',
                minWidth: '220px',
                maxWidth: '220px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            },
            getHeaderProps: () => ({
                style: {
                    width: '220px',
                    minWidth: '220px',
                    maxWidth: '220px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            }),
            getCellProps: () => ({
                style: {
                    width: '220px',
                    minWidth: '220px',
                    maxWidth: '220px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            })
        },
        {
            Header: this.props.t('dashboard.location'),
            accessor: 'location_info',
            Cell: (props) => {
                return <span>{props.value || '-'}</span>
            },
            width: 180
        },
        {
            Header: this.props.t('dashboard.by'),
            accessor: 'user',
            width: 150
        }
    ]

    handleWindowResize = () => {
        this.setState({ windowWidth: window.innerWidth });
    };

    translateRoomName = (name) => {
        const { t } = this.props;
        if (!name) return name;

        const translations = {
            'Assembly Room': t('dashboard.assemblyRoom'),
            'Utility Room': t('dashboard.utilityRoom'),
            'Sala de Utilidades': t('dashboard.utilityRoom'),
            'Sala de Utilidade': t('dashboard.utilityRoom'),
            'Cold Room': t('dashboard.coldRoom'),
            'Cold Room 1': t('dashboard.coldRoom') + ' 1',
            'Cold Room 2': t('dashboard.coldRoom') + ' 2',
            'Assembly Room 2': t('dashboard.assemblyRoom') + ' 2',
            'Finished Product Storage': t('dashboard.finishedProductStorage'),
            'Storage Room': t('dashboard.storageRoom'),
            'Sala de Armazenamento': t('dashboard.storageRoom'),
            'Armazenamento': t('dashboard.storageRoom'),
            'Hygiene Room': t('dashboard.hygieneRoom'),
            'Sala de Higiene': t('dashboard.hygieneRoom'),
            'Sala Higiene': t('dashboard.hygieneRoom'),
            'Incoming Goods Room': t('dashboard.incomingGoodsRoom'),
            'Sala de Recebimento de Mercadorias': t('dashboard.incomingGoodsRoom'),
            'Sala de Recebimento de Mercadoria': t('dashboard.incomingGoodsRoom'),
            'Recebimento de Mercadoria': t('dashboard.incomingGoodsRoom'),
            'Recebimento de mercadoria': t('dashboard.incomingGoodsRoom'),
            'Castle': t('dashboard.castle'),
            'Castelo': t('dashboard.castle'),
            'Door Handle': t('dashboard.doorHandle'),
            'Door Surface': t('dashboard.doorSurface'),
            'Chair': t('dashboard.chair')
        };

        return translations[name] || name;
    };

    renderCustomizedLabelRoom = (props) => {
        const { x, y, value, width, height, payload, viewBox } = props;
        const translatedValue = this.translateRoomName(value);
        // Quando position="bottom", o y já vem posicionado na base da barra
        // Precisamos usar uma posição Y fixa baseada no viewBox do gráfico
        // Todos os labels devem usar a mesma posição Y absoluta
        const baseY = viewBox?.y || 0;
        const chartHeight = viewBox?.height || 400;
        // Posição fixa: base do gráfico + offset fixo
        const fixedY = baseY + chartHeight + 60;
        const centerX = x + width / 2;

        // Quebrar texto em linhas se for muito longo (mais de 20 caracteres)
        const maxCharsPerLine = 20;
        let lines = [];
        if (translatedValue.length > maxCharsPerLine) {
            const words = translatedValue.split(' ');
            let currentLine = '';
            words.forEach(word => {
                if ((currentLine + ' ' + word).length <= maxCharsPerLine) {
                    currentLine = currentLine ? currentLine + ' ' + word : word;
                } else {
                    if (currentLine) lines.push(currentLine);
                    currentLine = word;
                }
            });
            if (currentLine) lines.push(currentLine);
        } else {
            lines = [translatedValue];
        }

        const lineHeight = 12;
        const totalHeight = lines.length * lineHeight;
        const startY = fixedY - (totalHeight / 2) + (lineHeight / 2);

        return (
            <g transform={`rotate(-45 ${centerX} ${fixedY})`}>
                {lines.map((line, index) => (
                    <text
                        key={index}
                        x={centerX}
                        y={startY + (index * lineHeight)}
                        fill="#8E90C0"
                        fontSize={10}
                        textAnchor="middle"
                    >
                        {line}
                    </text>
                ))}
            </g>
        );
    };

    renderCustomizedLabelUnit = (props) => {
        const { x, y, value, width, height, viewBox } = props;
        const translatedValue = this.translateRoomName(value);
        // Posição fixa baseada no viewBox do gráfico
        const baseY = viewBox?.y || 0;
        const chartHeight = viewBox?.height || 400;
        const fixedY = baseY + chartHeight + 90;
        return (
            <text
                x={x + width / 2}
                y={fixedY}
                fill="#8E90C0"
                fontSize={10}
                textAnchor="middle"
                transform={`rotate(-45 ${x + width / 2} ${fixedY})`}
            >
                {translatedValue}
            </text>
        );
    };

    tiltedAxisTick = (props) => {
        const { x, y, payload } = props;
        return (
            <g transform={`translate(${x},${y})`}>
                <text
                    x={0}
                    y={0}
                    dy={16}
                    textAnchor="end"
                    fill="#666"
                    transform="rotate(-45)">
                    {payload.value}
                </text>
            </g>
        )
    }

    onSelectBuilding = (event) => {
        const { value, selectedOptions } = event.target
        this.setState({
            ...this.state,
            building: value,
            buildingId: selectedOptions[0].id,
            buildingName: selectedOptions[0].innerText,
        }, this.applyFilter)
    }

    applyFilter = () => {
        this.props.fetchSampleCount({
            filter_type: this.state.filterType,
            building_id: this.state.buildingId,
            samples_period: this.state.SamplesPeriod,
            ct_period: this.state.CTPeriod,
            biome_period: this.state.biome_period,
            complex_period: this.state.complex_period,
            seq_period: this.state.seq_period,
            species_start_date: this.state.speciesStartDate,
        })
        if (this.props.fetchLocationTrend) {
            this.props.fetchLocationTrend({
                building_id: this.state.buildingId,
                samples_period: this.state.SamplesPeriod,
            })
        }
    }

    handleChangeSelectRight = (event) => {
        let date = new Date()
        let currentDate = new Date()
        date.setDate(date.getDate() - parseInt(event.target.value));
        date = moment(date).format('DD MMM YYYY')
        this.setState({
            startDateRight: date,
            endDateRight: moment(currentDate).format('DD MMM YYYY'),
            dateSelectedRight: event.target.value
        })
        this.setState({
            [event.target.name]: event.target.value,
        }, this.applyFilter)
    }

    handleChangeSelect = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
        }, this.applyFilter)
    }

    clearSampleLocations = () => this.setState({
        buildingId: "",
        building: "",
        SamplesPeriod: "",
        dateSelectedRight: "",
    }, this.applyFilter)

    customizedTooltipChartGraph = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            const { t } = this.props;
            const data = payload[0]?.payload || {};
            const { building, floor, room, unit } = data;

            // Construir a linha de informações de localização traduzida
            let locationInfo = [];
            if (building) {
                locationInfo.push(`${t('dashboard.building')} ${building}`);
            }
            if (floor) {
                // Traduzir "Floor" para o idioma apropriado
                let translatedFloor = floor;
                if (typeof floor === 'string') {
                    translatedFloor = floor.replace(/Floor/gi, t('dashboard.floor'));
                }
                locationInfo.push(translatedFloor);
            }
            if (room) {
                const translatedRoom = this.translateRoomName(room);
                locationInfo.push(`${t('dashboard.room')}: ${translatedRoom}`);
            }
            if (unit) {
                const translatedUnit = this.translateRoomName(unit);
                locationInfo.push(`${t('dashboard.unit')}: ${translatedUnit}`);
            }

            return (
                <div className="chart-tooltip">
                    {locationInfo.length > 0 && (
                        <p className="label">{locationInfo.join(', ')}</p>
                    )}
                    <p className="label">{t('dashboard.samplesCollected')}: {`${payload[0].value}`}</p>
                    <p className="label">{t('dashboard.samplesFinalized')}: {`${payload[1].value}`}</p>
                </div>
            );
        }
        return null;
    };

    renderCustomizedLabelBuilding = (props) => {
        const { x, y, value, width, height } = props;
        const { t } = this.props;

        // Traduzir "Floor" para "Andar"
        let translatedValue = value;
        if (value && typeof value === 'string') {
            translatedValue = value.replace(/Floor/gi, t('dashboard.floor'));
        }

        return (
            <g>
                <text
                    x={x + width / 2}
                    y={y}
                    dy={-4}
                    className='bartipData'
                    textAnchor="middle"
                    fontSize={10}
                >
                    {translatedValue}
                </text>
            </g>
        );
    }

    clear_dates = () => {
        this.setState({
            speciesStartDate: "",
            speciesEndDate: "",
            speciesMonth: "",
            speciesYear: "",
            biome_period: ""
        }, this.applyFilter)
    }

    onYearChange = (name, date) => {
        this.setState({
            speciesStartDate: date,
            speciesYear: date,
            speciesEndDate: (name === "speciesYear") ? "" : this.state.speciesEndDate,
            speciesMonth: (name === "speciesYear") ? "" : this.state.speciesMonth,
        },
            () => { this.applyFilter() })
    }

    onMonthChange = (name, date) => {
        this.setState({
            speciesStartDate: date,
            speciesMonth: date,
            speciesEndDate: (name === "speciesMonth") ? "" : this.state.speciesEndDate,
            speciesYear: (name === "speciesMonth") ? "" : this.state.speciesYear,
        },
            () => { this.applyFilter() })
    }

    getWeek = date => {
        let dates = []
        if (date !== "")
            for (let i = 0; i < 7; i++) {
                let currDate = new Date(moment(date).add(i, 'days'))
                if (currDate > new Date())
                    break
                dates.push(currDate)
            }
        return dates
    }

    onDateChange = (nameStart, nameEnd, date) => {
        let today = new Date(new Date().toDateString())
        let lastDate = new Date(moment(date).add(6 - moment(date).day(), 'days'))
        let firstDate = moment(date).subtract(moment(date).day(), 'days')
        let presentWeek = moment(today).subtract(moment(today).day(), 'days')
        this.setState({
            speciesStartDate: new Date(presentWeek.diff(firstDate, 'days') > 0 ? firstDate : presentWeek.subtract(6 - moment(today).day(), 'days')),
            speciesEndDate: lastDate > today ? today : lastDate,
            speciesMonth: (nameStart === "speciesStartDate") ? "" : this.state.speciesMonth,
            speciesYear: (nameStart === "speciesStartDate") ? "" : this.state.speciesYear,
        },
            () => { this.applyFilter() })
    }

    render() {
        const { recent_activity } = this.props.dashboardData
        const windowWidth = this.props.windowWidth;
        return (
            <div >
                {windowWidth > 650 ?
                    <ResponsiveReactGridLayout
                        {...this.props}
                        layouts={this.state.layouts}
                        onBreakpointChange={this.onBreakpointChange}
                        breakpoints={{ lg: 1500, lm: 1176, md: 1175, sm: 850, xs: 480 }}
                        onLayoutChange={this.onLayoutChange}
                        measureBeforeMount={false}
                        useCSSTransforms={this.state.mounted}
                        compactType={this.state.compactType}
                        preventCollision={!this.state.compactType}
                        isResizable={false}
                        isBounded={true}
                        isDraggable={this.props.canEdit}
                    >
                        <div key={'samples-collected'} className="stats-heading-normal">
                            <Card className="card-elements h-100" data-tut="reactour__samples">
                                <CardBody className="body-text">
                                    <Row className="nowrap-item">
                                        <Col>
                                            <Row className="nowrap-item left-margin">
                                                <CardImg className="card-icons" src={Samples} alt="" />
                                                <Col className="card-header">{this.props.t('dashboard.sampleCollected')}</Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <hr className="border-line" />
                                    <Row className="nowrap-item">
                                        <Col className="left-padding">
                                            <Row className="nowrap-item">
                                                <CardImg
                                                    src={totalCollected}
                                                    alt=""
                                                    left
                                                    className="card-image"
                                                />
                                                <Col>
                                                    <CardText>
                                                        {this.props.dashboardData.totalSamples > 0
                                                            ? this.props.dashboardData.totalSamples
                                                            : 0}
                                                    </CardText>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <CardText className="footer-text">{this.props.t('dashboard.totalCollected')}</CardText>
                                            </Row>
                                        </Col>
                                        <Col className="left-padding">
                                            <Row className="nowrap-item">
                                                <CardImg src={inProgress} alt="" left className="card-image" />
                                                <Col>
                                                    <CardText className="total-samples">
                                                        {this.props.dashboardData.total_waiting_samples > 0
                                                            ? this.props.dashboardData.total_waiting_samples
                                                            : 0}
                                                    </CardText>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <CardText className="footer-text">{this.props.t('dashboard.inProgress')}</CardText>
                                            </Row>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </div>
                        <div key={'type-of-analysis'} className="stats-heading-normal">
                            <Card className="card-elements h-100" data-tut="reactour__results">
                                <CardBody className="body-text variations-card">
                                    <Row className="nowrap-item last-card-padding">
                                        <CardImg className="card-icons" src={TypeOfVariation} alt="" />
                                        <Col className="card-header">{this.props.t('dashboard.typeOfVariation')}</Col>
                                    </Row>
                                    <hr className="border-line variation-card-border break-line" />
                                    <Row className="dashboard-last-card-row">
                                        <Col className="dashboard-last-card-column">
                                            <Row className="nowrap-item">
                                                <CardImg
                                                    src={typeOfVariationinShade}
                                                    alt=""
                                                    left
                                                    className="card-image"
                                                />
                                                <Col>
                                                    <CardText>
                                                        {this.props.dashboardData.total_cgMLST_samples > 0
                                                            ? this.props.dashboardData.total_cgMLST_samples
                                                            : 0}
                                                    </CardText>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <CardText className="footer-text-lastcard cgmlst-card">
                                                    cgMLST
                                                </CardText>
                                            </Row>
                                            <Row className="dashboard-last-card-row" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <pre className="last-card-sufix1" style={{ margin: 0 }}>
                                                    {this.props.dashboardData.waiting_cgMLST_samples > 0
                                                        ? this.props.dashboardData.waiting_cgMLST_samples
                                                        : 0}
                                                </pre>
                                                <Col className="last-card-sufix" style={{ padding: 0 }}>{this.props.t('dashboard.inProgress')}</Col>
                                            </Row>
                                        </Col>
                                        {windowWidth > 424 ? (
                                            <Col className="padding-left-sm">
                                                <Row>
                                                    <Col>
                                                        <CardText>
                                                            {this.props.dashboardData.total_SNP_samples > 0
                                                                ? this.props.dashboardData.total_SNP_samples
                                                                : 0}
                                                        </CardText>
                                                    </Col>
                                                </Row>
                                                <Row className="dashboard-last-card-row">
                                                    <CardText className="footer-text-lastcard">SNP</CardText>
                                                </Row>
                                                <Row className="dashboard-last-card-row" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                    <pre className="last-card-sufix1" style={{ margin: 0 }}>
                                                        {this.props.dashboardData.waiting_SNP_samples > 0
                                                            ? this.props.dashboardData.waiting_SNP_samples
                                                            : 0}
                                                    </pre>
                                                    <Col className="last-card-sufix" style={{ padding: 0 }}>{this.props.t('dashboard.inProgress')}</Col>
                                                </Row>
                                            </Col>
                                        ) : null}
                                        <Col className="padding-left-sm">
                                            <Row>
                                                <Col>
                                                    <CardText>
                                                        {this.props.dashboardData.total_Microbiome_samples > 0
                                                            ? this.props.dashboardData.total_Microbiome_samples
                                                            : 0}
                                                    </CardText>
                                                </Col>
                                            </Row>
                                            <Row className="dashboard-last-card-row">
                                                <CardText className="footer-text">{this.props.t('dashboard.microbiome')}</CardText>
                                            </Row>
                                            <Row className="dashboard-last-card-row" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <pre className="last-card-sufix1" style={{ margin: 0 }}>
                                                    {this.props.dashboardData.waiting_Microbiome_samples > 0
                                                        ? this.props.dashboardData.waiting_Microbiome_samples
                                                        : 0}
                                                </pre>
                                                <Col className="last-card-sufix" style={{ padding: 0 }}>{this.props.t('dashboard.inProgress')}</Col>
                                            </Row>
                                        </Col>
                                        <Col>
                                            <Row>
                                                <Col>
                                                    <CardText>
                                                        {this.props.dashboardData.total_Other_samples > 0
                                                            ? this.props.dashboardData.total_Other_samples
                                                            : 0}
                                                    </CardText>
                                                </Col>
                                            </Row>
                                            <Row className="dashboard-last-card-row">
                                                <CardText className="footer-text">{this.props.t('dashboard.other')}</CardText>
                                            </Row>
                                            <Row className="dashboard-last-card-row" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <pre className="last-card-sufix1" style={{ margin: 0 }}>
                                                    {this.props.dashboardData.waiting_Other_samples > 0
                                                        ? this.props.dashboardData.waiting_Other_samples
                                                        : 0}
                                                </pre>
                                                <Col className="last-card-sufix" style={{ padding: 0 }}>{this.props.t('dashboard.inProgress')}</Col>
                                            </Row>
                                        </Col>
                                        <Col className="result-card">
                                            <Row className="nowrap-item">
                                                <Col>
                                                    <Row>
                                                        <CardText className="result-card-positive">
                                                            {this.props.dashboardData.positive_result > 0
                                                                ? this.props.dashboardData.positive_result
                                                                : 0}
                                                        </CardText>
                                                    </Row>
                                                    <Row>
                                                        <CardText className="result-card-positive">Po</CardText>
                                                    </Row>
                                                </Col>
                                                <Col>
                                                    <Row>
                                                        <CardText className="result-card-negative">
                                                            {this.props.dashboardData.negative_result > 0
                                                                ? this.props.dashboardData.negative_result
                                                                : 0}
                                                        </CardText>
                                                    </Row>
                                                    <Row>
                                                        <CardText className="result-card-negative">Ne</CardText>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </div>
                        <div key={'sample-result-distro-graph'}
                            className={windowWidth > 1450 ? "graph bargraph-normal" : "graph-small bargraph-small-normal"}
                            data-tut="reactour__graphtwo"
                        >
                            <Row className="nowrap-item padding-header-graph">
                                <CardImg className="card-icons" src={secondGraph} alt="" />
                                <Col className="card-header">
                                    {this.props.t('dashboard.sampleResultDistributionOnFloor')}
                                </Col>
                                <Col style={{ textAlign: 'right', paddingRight: '12px' }}>
                                    <button
                                        onClick={() => this.setState({ showTrendModal: true })}
                                        style={{
                                            background: '#243682',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '8px',
                                            padding: '4px 12px',
                                            fontSize: '12px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        📊 Ver Tendências
                                    </button>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col className="dashboard-label-names">{this.props.t('dashboard.building')}</Col>
                                <Col className="graph-filters">
                                    <Input
                                        className="edit-input-values-dashboard"
                                        type="select"
                                        name="building"
                                        value={this.state.building}
                                        onChange={this.onSelectBuilding}
                                        size="1"
                                    >
                                        <option value="" default>
                                            {this.props.t('dashboard.building')}*
                                        </option>
                                        {this.props.buildingList.map((building, key) => {
                                            return (
                                                <option
                                                    id={building.id}
                                                    key={key}
                                                    value={building.building_id}
                                                >
                                                    {building.building_name}
                                                </option>
                                            );
                                        })}
                                    </Input>
                                </Col>
                                <Col className="graph-filters">
                                    <Input
                                        className="edit-input-values-dashboard"
                                        id="period"
                                        type="select"
                                        name="SamplesPeriod"
                                        value={this.state.SamplesPeriod}
                                        onChange={this.handleChangeSelectRight}
                                        size="1"
                                    >
                                        <option value="" default>
                                            {this.props.t('dashboard.period')}*
                                        </option>
                                        <option value="2">Last 2 days</option>
                                        <option value="7">Last 7 days</option>
                                        <option value="28">Last 4 weeks</option>
                                        <option value="365">1 Year</option>
                                    </Input>
                                </Col>
                                <Col className="dash-clear-button-right">
                                    <button
                                        type="reset"
                                        onClick={this.clearSampleLocations}
                                        className="graph-button-1"
                                    >
                                        {this.props.t('dashboard.clearFilter')}{" "}
                                    </button>
                                </Col>
                            </Row>
                            <Row>
                                {this.state.dateSelectedRight ? (
                                    <Col className="period-display">
                                        <img src={calender} height="15" width="15"></img>{" "}
                                        <div className="date-display">
                                            {this.state.startDateRight} to {this.state.endDateRight}
                                        </div>
                                    </Col>
                                ) : (
                                    <Col className="period-display">
                                        <br></br>
                                    </Col>
                                )}
                            </Row>
                            <ResponsiveContainer width="95%" height={700}>
                                <ComposedChart
                                    className="pie-chart-right"
                                    height={400}
                                    isAnimationActive={true}
                                    data={
                                        this.props.dashboardData.locations_count &&
                                            this.props.dashboardData.locations_count.length
                                            ? this.props.dashboardData.locations_count.slice(0, 10)
                                            : [
                                                {
                                                    location__description: "",
                                                    Samples: 0,
                                                    Results: 0,
                                                    building: "",
                                                    unit: "",
                                                    floor: "",
                                                    room: "",
                                                },
                                            ]
                                    }
                                    margin={{
                                        top: 10,
                                        right: 0,
                                        left: 0,
                                        bottom: 150,
                                    }}
                                >
                                    <CartesianGrid strokeWidth={0.3} />
                                    <XAxis
                                        angle={0}
                                        textAnchor="start"
                                        interval={0}
                                        height={300}
                                        dataKey="location__description"
                                        stroke="#8E90C0"
                                        fontSize="10"
                                        offset={50}
                                        tick={false}
                                    />
                                    <YAxis
                                        axisLine={false}
                                        allowDecimals={false}
                                        stroke="#8E90C0"
                                        fontSize="10"
                                        width={30}
                                    />
                                    <Tooltip content={this.customizedTooltipChartGraph} />
                                    <Bar
                                        dataKey="Samples"
                                        barSize={20}
                                        fill="#6E93BF"
                                        radius={[5, 5, 0, 0]}
                                        background={{ fill: "#ECF1F7", radius: [5, 5, 0, 0] }}
                                        isAnimationActive={false}
                                    >
                                        <LabelList
                                            dataKey="floor"
                                            angle="45"
                                            content={this.renderCustomizedLabelBuilding}
                                        />
                                        <LabelList
                                            dataKey="room"
                                            position="bottom"
                                            offset={0}
                                            fill="#8E90C0"
                                            content={this.renderCustomizedLabelRoom}
                                        />
                                    </Bar>
                                    <Line
                                        type="monotone"
                                        dataKey="Results"
                                        stroke="#EE7D11"
                                        isAnimationActive={false}
                                    />
                                </ComposedChart>
                            </ResponsiveContainer>
                        </div>
                        {this.state.showTrendModal && (
                            <div style={{
                                position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                                background: 'rgba(0,0,0,0.5)', zIndex: 2000,
                                display: 'flex', alignItems: 'center', justifyContent: 'center'
                            }} onClick={() => this.setState({ showTrendModal: false })}>
                                <div style={{
                                    background: 'white', borderRadius: '12px', padding: '24px',
                                    width: '90%', maxWidth: '700px', maxHeight: '80vh', overflowY: 'auto'
                                }} onClick={e => e.stopPropagation()}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px' }}>
                                        <h5 style={{ margin: 0, color: '#2c3e50' }}>📊 Tendência de Contaminação por Local</h5>
                                        <button onClick={() => this.setState({ showTrendModal: false })}
                                            style={{ background: 'none', border: 'none', fontSize: '18px', cursor: 'pointer' }}>✕</button>
                                    </div>
                                    <LocationTrend trendData={this.props.locationTrendData} loading={false} />
                                </div>
                            </div>
                        )}
                        <div key={'abundance-species-graph'}
                            className={windowWidth > 1450 ? "graph bargraph-normal" : "graph-small bargraph-small-normal"}
                            data-tut="reactour__graphthree"
                        >
                            <Row className="nowrap-item padding-header-graph">
                                <CardImg className="card-icons" src={firstGraph} alt="" />
                                <Col className="card-header">{this.props.t('dashboard.abundanceOfSpeciesOverTime')}</Col>
                                <Col style={{ textAlign: 'right', paddingRight: '12px' }}>
                                    <button
                                        onClick={() => this.setState({ showSpeciesGraph: !this.state.showSpeciesGraph })}
                                        style={{
                                            background: '#243682',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '8px',
                                            padding: '4px 12px',
                                            fontSize: '12px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        {this.state.showSpeciesGraph ? '▲ Ocultar Gráfico' : '▼ Ver Gráfico'}
                                    </button>
                                </Col>
                            </Row>
                            <hr />
                            {this.state.showSpeciesGraph && (
                                <>
                                    <Row>
                                        <Col className="dashboard-label-names">{this.props.t('dashboard.species')}</Col>
                                        <Col className="graph-filters dash-date-col">
                                            {this.state.biome_period === "Weekly" ? (
                                                <DatePicker
                                                    className="sample-input-fields form-control dashboard-datetime"
                                                    onChange={(date) => this.onDateChange("speciesStartDate", "speciesEndDate", date)}
                                                    showWeekNumbers
                                                    weekLabel="Week"
                                                    maxDate={new Date()}
                                                    selected={this.state.speciesEndDate}
                                                    dayClassName={(date) => {
                                                        return this.state.speciesStartDate <= date && this.state.speciesEndDate >= date ? "dashDay" : undefined;
                                                    }}
                                                    highlightDates={this.getWeek(this.state.highlightDates)}
                                                    onDayMouseEnter={(date) => {
                                                        let today = new Date(new Date().toDateString());
                                                        let firstDate = moment(date).subtract(moment(date).day(), "days");
                                                        let presentWeek = moment(today).subtract(moment(today).day(), "days");
                                                        this.setState({
                                                            highlightDates: new Date(
                                                                presentWeek.diff(firstDate, "days") > 0
                                                                    ? firstDate
                                                                    : presentWeek.subtract(6 - moment(today).day(), "days")
                                                            ),
                                                        });
                                                    }}
                                                    onCalendarClose={() => this.setState({ highlightDates: "" })}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    placeholderText="Week*"
                                                    dateFormat="wo 'Week of' yyyy"
                                                />
                                            ) : this.state.biome_period === "Monthly" ? (
                                                <DatePicker
                                                    className="form-control sample-input-fields dashboard-datetime"
                                                    onChange={(date) => this.onMonthChange("speciesMonth", date)}
                                                    showMonthYearPicker
                                                    showFullMonthYearPicker
                                                    selected={this.state.speciesMonth}
                                                    maxDate={new Date()}
                                                    dateFormat="MMMM yyyy"
                                                    placeholderText="Month*"
                                                />
                                            ) : this.state.biome_period === "Yearly" ? (
                                                <DatePicker
                                                    className="form-control sample-input-fields dashboard-datetime"
                                                    onChange={(date) => this.onYearChange("speciesYear", date)}
                                                    showYearDropdown
                                                    showYearPicker
                                                    selected={this.state.speciesYear}
                                                    maxDate={new Date()}
                                                    dateFormat="yyyy"
                                                    placeholderText="Year*"
                                                />
                                            ) : (
                                                <DatePicker
                                                    className="form-control sample-input-fields dashboard-datetime"
                                                    placeholderText={`${this.props.t('dashboard.date')}*`}
                                                    disabled={true}
                                                />
                                            )}
                                        </Col>
                                        <Col className="graph-filters">
                                            <Input
                                                className="edit-input-values-dashboard"
                                                id="period"
                                                type="select"
                                                name="biome_period"
                                                value={this.state.biome_period}
                                                onChange={this.handleChangeSelect}
                                                size="1"
                                            >
                                                <option value="" default>{this.props.t('dashboard.period')}*</option>
                                                <option value="Weekly">Weekly</option>
                                                <option value="Monthly">Monthly</option>
                                                <option value="Yearly">Yearly</option>
                                            </Input>
                                        </Col>
                                        <Col className="dash-clear-button">
                                            <button type="reset" onClick={this.clear_dates} className="graph-button-1">
                                                {this.props.t('dashboard.clearFilter')}
                                            </button>
                                        </Col>
                                    </Row>
                                    <ResponsiveContainer width="95%">
                                        <LineChart
                                            className="pieChart"
                                            data={
                                                this.props.dashboardData.microbiome_samples !== undefined
                                                    ? this.props.dashboardData.microbiome_samples.length > 0
                                                        ? this.props.dashboardData.microbiome_samples
                                                        : [{ name: "" }]
                                                    : [{ name: "" }]
                                            }
                                            margin={{ top: 5, right: 5, left: 0, bottom: 5 }}
                                            isAnimationActive={false}
                                            barCategoryGap="65%"
                                            dx={-20}
                                        >
                                            <CartesianGrid strokeWidth={0.2} />
                                            <XAxis type="category" fontSize="10" height={80} dataKey="name" stroke="#8E90C0"
                                                label={{ value: this.props.t('dashboard.timePeriod') }} />
                                            <YAxis type="number" fontSize="10" height={80} stroke="#003883"
                                                label={{ value: "% of DNA found", angle: -90, position: "insideLeft" }} />
                                            <Tooltip />
                                            <Legend layout="horizontal" verticalAlign="top" align="right" />
                                            {this.props.dashboardData.microbiome_samples ? (
                                                <>
                                                    {this.props.dashboardData.microbiome_samples.length > 0 &&
                                                        Object.keys(this.props.dashboardData.microbiome_samples[0]).map((species, index) => {
                                                            if (index === 0) return null;
                                                            return (
                                                                <Line isAnimationActive={false} dataKey={species}
                                                                    stroke={colors[index]} strokeWidth={1.5} dot={true} />
                                                            );
                                                        })}
                                                </>
                                            ) : null}
                                        </LineChart>
                                    </ResponsiveContainer>
                                </>
                            )}
                        </div>
                        <div key={'recent-activity-table'}
                            className={windowWidth > 1450 ? "bargraph-normal recent-small" : "bargraph-small-normal recent-small"}
                            data-tut="reactour__recent"
                        >
                            <Row className="nowrap-item padding-header-graph">
                                <CardImg className='card-icons' src={recentActivityIcon} alt="" />
                                <Col className="card-header">{this.props.t('dashboard.recentActivity')}</Col>
                            </Row>
                            <hr />
                            <ResponsiveContainer>
                                <div className="recent">
                                    {recent_activity !== undefined ? recent_activity.length > 0 ?
                                        <div className="recent-table">
                                            <ReactTable className="Data-Table"
                                                data={recent_activity}
                                                resizable={false}
                                                columns={this.columns}
                                                showPagination={false}
                                                minRows={0}
                                                sortable={true}
                                            />
                                        </div>
                                        : null : null
                                    }
                                </div>
                            </ResponsiveContainer>
                        </div>
                        <div key={'status-amostra'} className="graph monitoring-table-card">
                            <Row className="nowrap-item padding-header-graph">
                                <Col className="card-header">📊 Status da Amostra</Col>
                            </Row>
                            <hr />
                            <table style={{ width: '100%', fontSize: '13px' }}>
                                <thead><tr><th>Status</th><th>Número de Amostras</th></tr></thead>
                                <tbody>
                                    {(this.props.dashboardData?.status_amostra_count || []).map((item, i) => (
                                        <tr key={i}><td>{item.status_amostra}</td><td>{item.count}</td></tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div key={'avaliacao'} className="monitoring-table-card">
                            <Row className="nowrap-item padding-header-graph">
                                <Col className="card-header">✅ Avaliação</Col>
                            </Row>
                            <hr />
                            <table style={{ width: '100%', fontSize: '13px' }}>
                                <thead><tr><th>Avaliadores</th><th>Número de Amostras</th></tr></thead>
                                <tbody>
                                    {(this.props.dashboardData?.avaliacao_count || []).map((item, i) => (
                                        <tr key={i}><td>{item.avaliacao}</td><td>{item.count}</td></tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div key={'nome-teste'} className="monitoring-table-card">
                            <Row className="nowrap-item padding-header-graph">
                                <Col className="card-header">🧪 Nome do Teste</Col>
                            </Row>
                            <hr />
                            <table style={{ width: '100%', fontSize: '13px' }}>
                                <thead><tr><th>Nome do Teste</th><th>Aprovado</th><th>Reprovado</th><th>Total</th></tr></thead>
                                <tbody>
                                    {Object.entries(
                                        (this.props.dashboardData?.nome_teste_count || []).reduce((acc, item) => {
                                            if (!acc[item.nome_teste]) acc[item.nome_teste] = { aprovado: 0, reprovado: 0 };
                                            if (item.avaliacao === 'Aprovado') acc[item.nome_teste].aprovado += item.count;
                                            else if (item.avaliacao === 'Reprovado') acc[item.nome_teste].reprovado += item.count;
                                            return acc;
                                        }, {})
                                    ).map(([nome, vals], i) => (
                                        <tr key={i}>
                                            <td>{nome}</td>
                                            <td>{vals.aprovado || '-'}</td>
                                            <td>{vals.reprovado || '-'}</td>
                                            <td><strong>{vals.aprovado + vals.reprovado}</strong></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div key={'numerical-value-chart'} className="monitoring-table-card">
                            <Row className="nowrap-item padding-header-graph">
                                <Col className="card-header">📈 Resultados Quantitativos</Col>
                            </Row>
                            <hr />
                            <ResponsiveContainer width="95%" height={300}>
                                <ComposedChart data={(this.props.dashboardData?.numerical_value_by_date || []).map(d => ({
                                    date: d.start_analyse_date ? new Date(d.start_analyse_date).toLocaleDateString('pt-BR') : '',
                                    count: d.count
                                }))}>
                                    <CartesianGrid strokeWidth={0.3} />
                                    <XAxis dataKey="date" fontSize="10" stroke="#8E90C0" tick={false} />
                                    <YAxis fontSize="10" stroke="#8E90C0" />
                                    <Tooltip />
                                    <Bar dataKey="count" fill="#6E93BF" radius={[3, 3, 0, 0]} isAnimationActive={false} />
                                </ComposedChart>
                            </ResponsiveContainer>
                        </div>
                        <div key={'sample-description'} className="monitoring-table-card">
                            <Row className="nowrap-item padding-header-graph">
                                <Col className="card-header">📋 Sample Description</Col>
                            </Row>
                            <hr />
                            <table style={{ width: '100%', fontSize: '13px' }}>
                                <thead><tr><th>Descrição</th><th>Aprovado</th><th>Reprovado</th><th>Total</th></tr></thead>
                                <tbody>
                                    {Object.entries(
                                        (this.props.dashboardData?.sample_description_count || []).reduce((acc, item) => {
                                            if (!acc[item.sample_description]) acc[item.sample_description] = { aprovado: 0, reprovado: 0 };
                                            if (item.avaliacao === 'Aprovado') acc[item.sample_description].aprovado += item.count;
                                            else if (item.avaliacao === 'Reprovado') acc[item.sample_description].reprovado += item.count;
                                            return acc;
                                        }, {})
                                    ).map(([desc, vals], i) => (
                                        <tr key={i}>
                                            <td>{desc}</td>
                                            <td>{vals.aprovado || '-'}</td>
                                            <td>{vals.reprovado || '-'}</td>
                                            <td><strong>{vals.aprovado + vals.reprovado}</strong></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div key={'sala'} className="monitoring-table-card">
                            <Row className="nowrap-item padding-header-graph">
                                <Col className="card-header">🏠 Sala</Col>
                            </Row>
                            <hr />
                            <table style={{ width: '100%', fontSize: '13px' }}>
                                <thead><tr><th>Sala</th><th>Aprovado</th><th>Reprovado</th><th>Total</th></tr></thead>
                                <tbody>
                                    {Object.entries(
                                        (this.props.dashboardData?.sala_count || []).reduce((acc, item) => {
                                            const sala = item.sample__location__room__room_name;
                                            if (!acc[sala]) acc[sala] = { aprovado: 0, reprovado: 0 };
                                            if (item.avaliacao === 'Aprovado') acc[sala].aprovado += item.count;
                                            else if (item.avaliacao === 'Reprovado') acc[sala].reprovado += item.count;
                                            return acc;
                                        }, {})
                                    ).map(([sala, vals], i) => (
                                        <tr key={i}>
                                            <td>{sala}</td>
                                            <td>{vals.aprovado || '-'}</td>
                                            <td>{vals.reprovado || '-'}</td>
                                            <td><strong>{vals.aprovado + vals.reprovado}</strong></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div key={'heatmap-preview'}>
                            <HeatmapPreview />
                        </div>
                    </ResponsiveReactGridLayout> :
                    <ResponsiveReactGridLayout
                        {...this.props}
                        layouts={this.state.layouts}
                        onBreakpointChange={this.onBreakpointChange}
                        breakpoints={{ lg: 1400, lm: 1176, md: 1175, sm: 700, xs: 480 }}
                        onLayoutChange={this.onLayoutChange}
                        // WidthProvider option
                        measureBeforeMount={false}
                        // I like to have it animate on mount. If you don't, delete `useCSSTransforms` (it's default `true`)
                        // and set `measureBeforeMount={true}`.
                        useCSSTransforms={this.state.mounted}
                        compactType={this.state.compactType}
                        preventCollision={!this.state.compactType}
                        isResizable={false}
                        isBounded={true}
                        isDraggable={this.props.canEdit}
                    // containerPadding={'[0,0]'}
                    >
                        <div key={'samples-collected'} className="stats-heading-normal">
                            <Card className="card-elements h-100" data-tut="reactour__samples">
                                <CardBody className="body-text">
                                    <Row className="nowrap-item">
                                        <Col>
                                            <Row className="nowrap-item left-margin">
                                                <CardImg className="card-icons" src={Samples} alt="" />
                                                <Col className="card-header">{this.props.t('dashboard.sampleCollected')}</Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <hr className="border-line" />
                                    <Row className="nowrap-item">
                                        <Col className="left-padding">
                                            <Row className="nowrap-item">
                                                <CardImg
                                                    src={totalCollected}
                                                    alt=""
                                                    left
                                                    className="card-image"
                                                />
                                                <Col>
                                                    <CardText>
                                                        {this.props.dashboardData.totalSamples > 0
                                                            ? this.props.dashboardData.totalSamples
                                                            : 0}
                                                    </CardText>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <CardText className="footer-text">{this.props.t('dashboard.totalCollected')}</CardText>
                                            </Row>
                                        </Col>
                                        <Col className="left-padding">
                                            <Row className="nowrap-item">
                                                <CardImg src={inProgress} alt="" left className="card-image" />
                                                <Col>
                                                    <CardText className="total-samples">
                                                        {this.props.dashboardData.total_waiting_samples > 0
                                                            ? this.props.dashboardData.total_waiting_samples
                                                            : 0}
                                                    </CardText>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <CardText className="footer-text">{this.props.t('dashboard.inProgress')}</CardText>
                                            </Row>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </div>
                        <div key={'type-of-analysis'} className="stats-heading-normal">
                            <Card className="card-elements h-100" data-tut="reactour__results">
                                <CardBody className="body-text variations-card">
                                    <Row className="nowrap-item last-card-padding">
                                        <CardImg className="card-icons" src={TypeOfVariation} alt="" />
                                        <Col className="card-header">{this.props.t('dashboard.typeOfVariation')}</Col>
                                    </Row>
                                    <hr className="border-line variation-card-border break-line" />
                                    <Row className="dashboard-last-card-row">
                                        <Col className="dashboard-last-card-column">
                                            <Row className="nowrap-item">
                                                <CardImg
                                                    src={typeOfVariationinShade}
                                                    alt=""
                                                    left
                                                    className="card-image"
                                                />
                                                <Col>
                                                    <CardText>
                                                        {this.props.dashboardData.total_cgMLST_samples > 0
                                                            ? this.props.dashboardData.total_cgMLST_samples
                                                            : 0}
                                                    </CardText>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <CardText className="footer-text-lastcard cgmlst-card">
                                                    cgMLST
                                                </CardText>
                                            </Row>
                                            <Row className="dashboard-last-card-row" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <pre className="last-card-sufix1" style={{ margin: 0 }}>
                                                    {this.props.dashboardData.waiting_cgMLST_samples > 0
                                                        ? this.props.dashboardData.waiting_cgMLST_samples
                                                        : 0}
                                                </pre>
                                                <Col className="last-card-sufix" style={{ padding: 0 }}>{this.props.t('dashboard.inProgress')}</Col>
                                            </Row>
                                        </Col>
                                        {windowWidth > 424 ? (
                                            <Col className="padding-left-sm">
                                                <Row>
                                                    <Col>
                                                        <CardText>
                                                            {this.props.dashboardData.total_SNP_samples > 0
                                                                ? this.props.dashboardData.total_SNP_samples
                                                                : 0}
                                                        </CardText>
                                                    </Col>
                                                </Row>
                                                <Row className="dashboard-last-card-row">
                                                    <CardText className="footer-text-lastcard">SNP</CardText>
                                                </Row>
                                                <Row className="dashboard-last-card-row" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                    <pre className="last-card-sufix1" style={{ margin: 0 }}>
                                                        {this.props.dashboardData.waiting_SNP_samples > 0
                                                            ? this.props.dashboardData.waiting_SNP_samples
                                                            : 0}
                                                    </pre>
                                                    <Col className="last-card-sufix" style={{ padding: 0 }}>{this.props.t('dashboard.inProgress')}</Col>
                                                </Row>
                                            </Col>
                                        ) : null}
                                        <Col className="padding-left-sm">
                                            <Row>
                                                <Col>
                                                    <CardText>
                                                        {this.props.dashboardData.total_Microbiome_samples > 0
                                                            ? this.props.dashboardData.total_Microbiome_samples
                                                            : 0}
                                                    </CardText>
                                                </Col>
                                            </Row>
                                            <Row className="dashboard-last-card-row">
                                                <CardText className="footer-text">{this.props.t('dashboard.microbiome')}</CardText>
                                            </Row>
                                            <Row className="dashboard-last-card-row" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <pre className="last-card-sufix1" style={{ margin: 0 }}>
                                                    {this.props.dashboardData.waiting_Microbiome_samples > 0
                                                        ? this.props.dashboardData.waiting_Microbiome_samples
                                                        : 0}
                                                </pre>
                                                <Col className="last-card-sufix" style={{ padding: 0 }}>{this.props.t('dashboard.inProgress')}</Col>
                                            </Row>
                                        </Col>
                                        <Col>
                                            <Row>
                                                <Col>
                                                    <CardText>
                                                        {this.props.dashboardData.total_Other_samples > 0
                                                            ? this.props.dashboardData.total_Other_samples
                                                            : 0}
                                                    </CardText>
                                                </Col>
                                            </Row>
                                            <Row className="dashboard-last-card-row">
                                                <CardText className="footer-text">{this.props.t('dashboard.other')}</CardText>
                                            </Row>
                                            <Row className="dashboard-last-card-row" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <pre className="last-card-sufix1" style={{ margin: 0 }}>
                                                    {this.props.dashboardData.waiting_Other_samples > 0
                                                        ? this.props.dashboardData.waiting_Other_samples
                                                        : 0}
                                                </pre>
                                                <Col className="last-card-sufix" style={{ padding: 0 }}>{this.props.t('dashboard.inProgress')}</Col>
                                            </Row>
                                        </Col>
                                        <Col className="result-card">
                                            <Row className="nowrap-item">
                                                <Col>
                                                    <Row>
                                                        <CardText className="result-card-positive">
                                                            {this.props.dashboardData.positive_result > 0
                                                                ? this.props.dashboardData.positive_result
                                                                : 0}
                                                        </CardText>
                                                    </Row>
                                                    <Row>
                                                        <CardText className="result-card-positive">Po</CardText>
                                                    </Row>
                                                </Col>
                                                <Col>
                                                    <Row>
                                                        <CardText className="result-card-negative">
                                                            {this.props.dashboardData.negative_result > 0
                                                                ? this.props.dashboardData.negative_result
                                                                : 0}
                                                        </CardText>
                                                    </Row>
                                                    <Row>
                                                        <CardText className="result-card-negative">Ne</CardText>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </div>
                        <div key={'recent-activity-table'} className="alternate-recent-activity">
                            <div className="recent-activity-small-normal">
                                <Row
                                    className={windowWidth > 650 ? "bargraph-normal" : "bargraph-small-normal"}
                                    data-tut="reactour__recent"
                                >
                                    <Row className="nowrap-item padding-header-graph padding-header-top">
                                        <CardImg className="card-icons" src={recentActivityIcon} alt="" />
                                        <Col className="card-header">{this.props.t('dashboard.recentActivity')}</Col>
                                    </Row>
                                    <hr />
                                    <ResponsiveContainer>
                                        <div className="recent">
                                            {recent_activity !== undefined ? (
                                                recent_activity.length > 0 ? (
                                                    <div className="recent-table">
                                                        <ReactTable
                                                            className="Data-Table"
                                                            data={recent_activity}
                                                            resizable={false}
                                                            columns={this.columns}
                                                            showPagination={false}
                                                            minRows={0}
                                                            sortable={true}
                                                        />
                                                    </div>
                                                ) : null
                                            ) : null}
                                        </div>
                                    </ResponsiveContainer>
                                </Row>
                            </div>
                        </div>
                        <div key={'heatmap-preview'} className="heatmap-preview-container-small">
                            <HeatmapPreview />
                        </div>
                    </ResponsiveReactGridLayout>}

                {this.state.showTrendModal && (
                    <div style={{
                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                        background: 'rgba(0,0,0,0.5)', zIndex: 2000,
                        display: 'flex', alignItems: 'center', justifyContent: 'center'
                    }} onClick={() => this.setState({ showTrendModal: false })}>
                        <div style={{
                            background: 'white', borderRadius: '12px', padding: '24px',
                            width: '90%', maxWidth: '700px', maxHeight: '80vh', overflowY: 'auto'
                        }} onClick={e => e.stopPropagation()}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px' }}>
                                <h5 style={{ margin: 0, color: '#2c3e50' }}>📊 Tendência de Contaminação por Local</h5>
                                <button onClick={() => this.setState({ showTrendModal: false })}
                                    style={{ background: 'none', border: 'none', fontSize: '18px', cursor: 'pointer' }}>✕</button>
                            </div>
                            <LocationTrend trendData={this.props.locationTrendData} loading={false} />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

ShowcaseLayout.propTypes = {
    onLayoutChange: PropTypes.func.isRequired,
    canEdit: PropTypes.bool.isRequired,

};

ShowcaseLayout.defaultProps = {
    className: "layout",
    rowHeight: 30,
    onLayoutChange: function () { },
    cols: { lg: 12, lm: 12, md: 10, sm: 6, xs: 4, xxs: 2 },
    canEdit: false,
    dashboardData: null,
    buildingList: [],
    floorsList: [],
    initialLayout: {
        lg:
            [
                {
                    "x": 0,
                    "y": 30,
                    "w": 6,
                    "h": 10,
                    "i": "status-amostra",
                    "static": false
                },
                {
                    "x": 6,
                    "y": 30,
                    "w": 6,
                    "h": 10,
                    "i": "avaliacao",
                    "static": false
                },
                {
                    "x": 0,
                    "y": 40,
                    "w": 12,
                    "h": 12,
                    "i": "nome-teste",
                    "static": false
                },
                {
                    "x": 0,
                    "y": 52,
                    "w": 6,
                    "h": 14,
                    "i": "numerical-value-chart",
                    "static": false
                },
                {
                    "x": 6,
                    "y": 52,
                    "w": 6,
                    "h": 14,
                    "i": "sample-description",
                    "static": false
                },
                {
                    "x": 0,
                    "y": 66,
                    "w": 6,
                    "h": 12,
                    "i": "sala",
                    "static": false
                },
                {
                    "x": 0,
                    "y": 78,
                    "w": 12,
                    "h": 14,
                    "i": "heatmap-preview",
                    "static": false
                },
            ],
        lm:
            [
                {
                    "x": 0,
                    "y": 0,
                    "w": 4,
                    "h": 4,
                    "i": 'samples-collected',
                    "static": false
                },
                {
                    "x": 0,
                    "y": 4,
                    "w": 12,
                    "h": 4,
                    "i": 'type-of-analysis',
                    "static": false
                },
                {
                    "x": 8,
                    "y": 6,
                    "w": 6,
                    "h": 14,
                    "i": 'sample-result-distro-graph',
                    "static": false
                },
                {
                    "x": 0,
                    "y": 16,
                    "w": 6,
                    "h": 14,
                    "i": 'abundance-species-graph',
                    "static": false
                },
                {
                    "x": 6,
                    "y": 16,
                    "w": 6,
                    "h": 9,
                    "i": 'recent-activity-table',
                    "static": false
                }
            ],
        md:
            [
                {
                    "x": 0,
                    "y": 0,
                    "w": 2,
                    "h": 5,
                    "i": 'samples-collected',
                    "static": false
                },
                {
                    "x": 6,
                    "y": 0,
                    "w": 4,
                    "h": 5,
                    "i": 'type-of-analysis',
                    "static": false
                },
                {
                    "x": 5,
                    "y": 5,
                    "w": 5,
                    "h": 14,
                    "i": 'sample-result-distro-graph',
                    "static": false
                },
                {
                    "x": 0,
                    "y": 15,
                    "w": 5,
                    "h": 14,
                    "i": 'abundance-species-graph',
                    "static": false
                },
                {
                    "x": 5,
                    "y": 15,
                    "w": 5,
                    "h": 9,
                    "i": 'recent-activity-table',
                    "static": false
                }
            ],
        sm:
            [
                {
                    "x": 0,
                    "y": 0,
                    "w": 2,
                    "h": 5,
                    "i": 'samples-collected',
                    "static": false
                },
                {
                    "x": 2,
                    "y": 0,
                    "w": 4,
                    "h": 5,
                    "i": 'type-of-analysis',
                    "static": false
                },
                {
                    "x": 0,
                    "y": 20,
                    "w": 6,
                    "h": 14,
                    "i": 'sample-result-distro-graph',
                    "static": false
                },
                {
                    "x": 0,
                    "y": 30,
                    "w": 6,
                    "h": 14,
                    "i": 'abundance-species-graph',
                    "static": false
                },
                {
                    "x": 0,
                    "y": 40,
                    "w": 6,
                    "h": 9,
                    "i": 'recent-activity-table',
                    "static": false
                }
            ],
        xs:
            [
                {
                    "x": 0,
                    "y": 0,
                    "w": 4,
                    "h": 5,
                    "i": 'samples-collected',
                    "static": false
                },
                {
                    "x": 0,
                    "y": 15,
                    "w": 4,
                    "h": 5,
                    "i": 'type-of-analysis',
                    "static": false
                },
                {
                    "x": 0,
                    "y": 30,
                    "w": 5,
                    "h": 14,
                    "i": 'sample-result-distro-graph',
                    "static": false
                },
                {
                    "x": 0,
                    "y": 40,
                    "w": 5,
                    "h": 14,
                    "i": 'abundance-species-graph',
                    "static": false
                },
                {
                    "x": 0,
                    "y": 50,
                    "w": 5,
                    "h": 9,
                    "i": 'recent-activity-table',
                    "static": false
                }
            ]
    },
};

export default withTranslation()(ShowcaseLayout);

